import { render } from "./UppMenuAccount.vue?vue&type=template&id=76b4e6da"
import script from "./UppMenuAccount.vue?vue&type=script&lang=js"
export * from "./UppMenuAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__